import { Box, Typography } from '@mui/material';
import React from 'react';

import { paramToSlug } from '../../../utils';

export const InvoiceDetailsGridItem = ({ label, value, link = '', icon = null }) => {
	const displayValue = typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value;

	return (
		<Box
			display='flex'
			flexDirection='row'
			gap='3%'
			style={{ width: '23%', minHeight: '40px', alignSelf: 'center' }}
		>
			<Typography
				sx={{
					fontWeight: 'bold',
					'& span': {
						fontWeight: 'normal',
						paddingLeft: '10px',
					},
				}}
				data-cy={`detail-section-${paramToSlug(label)}-text`}
			>
				{label}:{' '}
				{link ? (
					<a
						href={link}
						target={window.parent.Cypress ? '_self' : '_blank'}
						rel='noreferrer'
						style={{ textDecoration: 'none', color: 'blue' }}
					>
						<span>{displayValue}</span>
					</a>
				) : (
					<span>{displayValue}</span>
				)}
			</Typography>
			{!!icon && icon}
		</Box>
	);
};
